import { render, staticRenderFns } from "./FeAvatar.vue?vue&type=template&id=4ead9fae&"
import script from "./FeAvatar.vue?vue&type=script&lang=js&"
export * from "./FeAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports